<template lang="pug">
  #program-reports.box
    WtTile(ancestor :col="12")

    .card.mb-4
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Program Summary Report
            //- TODO  and badges won.
            small A summary of all program data including registrant information, step and activity data, registration question answers, and wellness metrics.
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="programSummaryStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding.pr-2
                BField(label="End Date").no-padding
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="programSummaryEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="programSummaryStartDate ? programSummaryStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding
                BField(:message="programSummaryReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="downloadMemberStats"
                  ).mt-5 DOWNLOAD
    .card.mb-4(v-if="showTeamsStuff")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Team Summary Report
            small A summary of all team data including activities, averages and participation percentage.
            WtTile(padding="small")
              small
                template()
                  BRadio.define-radio(
                    v-model="teamSummaryFilter"
                    :native-value="allTeamSummary"
                  )
                    | All team summary
                template()
                  BRadio.define-radio(
                    v-model="teamSummaryFilter"
                    :native-value="activeChallengeTeamSummary"
                  )
                    | Active challenge only
          WtTile(child :col="6").no-padding

            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="teamSummaryStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding.pr-2
                BField(label="End Date")
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="teamSummaryEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="teamSummaryStartDate ? teamSummaryStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                  )
              WtTile(child :col="4").no-padding
                BField(:message="teamSummaryReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="downloadTeamSummary"
                  ).mt-5 DOWNLOAD

    .card.mb-4(v-if="showTeamsStuff")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) All User Report
            small A list of all teams and team members.
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding
              WtTile(child :col="4").no-padding

              WtTile(child :col="4").no-padding

              WtTile(child :col="4").no-padding
                BField(:message="allUsersReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="allUsersReport"
                  ) DOWNLOAD
    .card.mb-4
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Points Summary Report
            //- TODO  and badges won.
            small A summary of all points earned by activity, metric, how points are earned or given shown at the member level
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="pointsSummaryStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding.pr-2
                BField(label="End Date").no-padding
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="pointsSummaryEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="pointsSummaryStartDate ? pointsSummaryStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding
                BField(:message="pointsSummaryReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="downloadPointsSummaryReport"
                  ).mt-5 DOWNLOAD
    .card.mb-4
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Badges Report
            //- TODO  and badges won.
            small A summary of badges earned by all members.
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="badgesStatsStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                  )
              WtTile(child :col="4").no-padding.pr-2
                BField(label="End Date").no-padding
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="badgesStatsEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="badgesStatsStartDate ? badgesStatsStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding
                BField(:message="badgeStatsReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingBadgesDownload"
                    @click.native="downloadBadgesStatsReport"
                  ).mt-5 DOWNLOAD
    .card.mb-4(v-if="showWellnessStuff")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Wellness Metrics Report
            //- TODO  and badges won.
            small Entries data by wellness metric by member
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="wellnessMetricStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding.pr-2
                BField(label="End Date").no-padding
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="wellnessMetricEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="wellnessMetricStartDate ? wellnessMetricStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding
                BField(:message="wellnessMetricReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="downloadWellnessMetricsReport"
                  ).mt-5 DOWNLOAD
    .card.mb-4(v-if="displayOrganizationReport")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Organization Summary Report
            //- TODO  and badges won.
            small A summary of organization movement activities
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="organizationSummaryStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding.pr-2
                BField(label="End Date").no-padding
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="organizationSummaryEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="organizationSummaryStartDate ? organizationSummaryStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                  )

              WtTile(child :col="4").no-padding
                BField(:message="pointsSummaryReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="downloadOrganizationSummaryReport"
                  ).mt-5 DOWNLOAD

    .card(v-if="hasResellerId")
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="6").no-padding
            WtTitle(h5) Reseller Aggregation Report
            small Aggregate member statistics across all reseller programs
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="4").no-padding

              WtTile(child :col="4").no-padding

              WtTile(child :col="4").no-padding
                BField(:message="resellerAggregateReportEmailSent ? 'Email Sent' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingResellerDownload"
                    @click.native="downloadResellerAggregateStats"
                  ) DOWNLOAD

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import MemberStatsTable from "@/components/Program/MemberStatsTable.vue";
import WtButton from "@@/WtButton/WtButton";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

const ALL_TEAM = 1;
const ACTIVE_CHALLENGE_ONLY = 0;

export default {
  name: "ProgramReports",

  components: { WtTitle, WtTile, MemberStatsTable, WtButton },

  mixins: [dateUtilityMixin],

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    members: {
      type: Object,
      default: null
    },
    fetchMembersAction: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      programSummaryStartDate: null,
      programSummaryEndDate: null,
      teamSummaryStartDate: null,
      teamSummaryEndDate: null,
      teamSummaryReportEmailSent: false,
      processingDownload: false,
      processingBadgesDownload: false,
      processingResellerDownload: false,
      programSummaryReportEmailSent: false,
      allUsersReportEmailSent: false,
      pointsSummaryStartDate: null,
      pointsSummaryEndDate: null,
      pointsSummaryReportEmailSent: false,
      wellnessMetricStartDate: null,
      wellnessMetricEndDate: null,
      wellnessMetricReportEmailSent: false,
      badgesStatsStartDate: null,
      badgesStatsEndDate: null,
      badgeStatsReportEmailSent: false,
      organizationSummaryStartDate: null,
      organizationSummaryEndDate: null,
      organizationSummaryReportEmailSent: false,
      resellerAggregateReportEmailSent: false,
      isNotProd: process.env.VUE_APP_ENV !== "prod",
      allTeamSummary: ALL_TEAM,
      activeChallengeTeamSummary: ACTIVE_CHALLENGE_ONLY,
      teamSummaryFilter: 1
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta", "isCoreTier", "isProTier"]),

    endDatePickerEvents() {
      return this.startDate ? [this.startDate] : null;
    },

    startDatePickerEvents() {
      return this.endDate ? [this.endDate] : null;
    },

    programStartDate() {
      return new Date(
        new Date(this.coreProgramMeta.startDate).setHours(0, 0, 0, 0)
      );
    },

    showTeamsStuff() {
      // All Program Types Can See Teams Stuff
      return true;
    },

    showWellnessStuff() {
      return this.$auth.user().program.isWellnessMetricsOn;
    },

    displayOrganizationReport() {
      return (
        this.isProTier &&
        this._.get(this.coreProgramMeta, "organizationsOn", false)
      );
    },

    hasResellerId() {
      return !!this.$auth.user().resellerId;
    },

    userResellerId() {
      return this.$auth.user().resellerId;
    }
  },

  methods: {
    ...mapActions("program", [
      "memberStatsDownload",
      "allUsersDownload",
      "teamSummaryDownload",
      "pointsSummaryDownload",
      "wellnessMetricsDownload",
      "badgesStatsDownload",
      "organizationSummaryDownload",
      "resellerAggregateStatsDownload"
    ]),
    ...mapActions(["snackBar"]),

    async allUsersReport() {
      this.processingDownload = true;
      this.allUsersReportEmailSent = false;
      const payload = {
        programId: this.coreProgramMeta.id
      };
      let response = await this.allUsersDownload(payload);

      // This is ... because the action, memberStatsDownload, transforms to arraybuffer ...
      var jsonResponse = false;
      try {
        // This errors when the arraybuffer is a csv...
        jsonResponse = JSON.parse(
          new TextDecoder().decode(new Uint8Array(response.data))
        );
      } catch (e) {
        jsonResponse = false;
      }
      try {
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.allUsersReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `all_users_report`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }
      } catch (error) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: this._.get(
            error,
            "data.error.message",
            `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
          )
        });
        console.log(
          "🚀 ~ file: ProgramReports.vue ~ line 225 ~ downloadAllUsersReport ~ error",
          error
        );
      }

      this.processingDownload = false;
    },

    downloadMemberStats() {
      this.processingDownload = true;

      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.programSummaryStartDate
          ? this.formatDateForRequest(this.programSummaryStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.programSummaryEndDate
          ? this.formatDateForRequest(this.programSummaryEndDate)
          : this.today().formatted
      };
      this.programSummaryReportEmailSent = false;
      this.memberStatsDownload(payload).then(response => {
        if (
          !this._.has(response, "data") ||
          this._.has(response, "data.error.message")
        ) {
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message: this._.get(
              response,
              "data.error.message",
              `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
            )
          });
        }
        // This is ... because the action, memberStatsDownload, transforms to arraybuffer ...
        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.programSummaryReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `stats_from_${payload.startDate}_to_${payload.endDate}`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }

        this.processingDownload = false;
      });
    },

    async downloadTeamSummary() {
      this.processingDownload = true;

      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.teamSummaryStartDate
          ? this.formatDateForRequest(this.teamSummaryStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.teamSummaryEndDate
          ? this.formatDateForRequest(this.teamSummaryEndDate)
          : this.today().formatted,
        isAllTeamSummary: this.teamSummaryFilter
      };
      try {
        let data = await this.teamSummaryDownload(payload);

        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.teamSummaryReportEmailSent = true;
        }
      } catch (error) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: error.statusText
        });
      }
      this.processingDownload = false;
    },

    downloadPointsSummaryReport() {
      this.processingDownload = true;

      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.pointsSummaryStartDate
          ? this.formatDateForRequest(this.pointsSummaryStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.pointsSummaryEndDate
          ? this.formatDateForRequest(this.pointsSummaryEndDate)
          : this.today().formatted
      };
      this.pointsSummaryReportEmailSent = false;
      this.pointsSummaryDownload(payload).then(response => {
        if (
          !this._.has(response, "data") ||
          this._.has(response, "data.error.message")
        ) {
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message: this._.get(
              response,
              "data.error.message",
              `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
            )
          });
        }

        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.pointsSummaryReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `points_stats_from_${payload.startDate}_to_${payload.endDate}`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }

        this.processingDownload = false;
      });
    },

    downloadWellnessMetricsReport() {
      this.processingDownload = true;

      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.wellnessMetricStartDate
          ? this.formatDateForRequest(this.wellnessMetricStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.wellnessMetricEndDate
          ? this.formatDateForRequest(this.wellnessMetricEndDate)
          : this.today().formatted
      };
      this.wellnessMetricReportEmailSent = false;
      this.wellnessMetricsDownload(payload).then(response => {
        if (
          !this._.has(response, "data") ||
          this._.has(response, "data.error.message")
        ) {
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message: this._.get(
              response,
              "data.error.message",
              `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
            )
          });
        }

        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.pointsSummaryReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `wellness_metrics_from_${payload.startDate}_to_${payload.endDate}`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }

        this.processingDownload = false;
      });
    },

    downloadBadgesStatsReport() {
      this.processingBadgesDownload = true;

      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.badgesStatsStartDate
          ? this.formatDateForRequest(this.badgesStatsStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.badgesStatsEndDate
          ? this.formatDateForRequest(this.badgesStatsEndDate)
          : this.today().formatted
      };
      this.badgeStatsReportEmailSent = false;
      this.badgesStatsDownload(payload)
        .then(response => {
          if (!response.data || response.error) {
            const errorMessage = response.error
              ? response.error.message
              : "An error has occurred. Please try again or contact wellness@be-engaged.co.";

            this.snackBar({
              duration: 10000,
              type: "is-danger",
              message: errorMessage
            });
          } else if (response.data) {
            let jsonResponse = false;
            try {
              // Try to parse response as JSON, may fail if the response is a CSV
              jsonResponse = JSON.parse(
                new TextDecoder().decode(new Uint8Array(response.data))
              );
            } catch (e) {
              jsonResponse = false;
            }

            if (
              jsonResponse.data &&
              jsonResponse.data.message === "sent_to_email"
            ) {
              this.snackBar({
                type: "is-info",
                message: `The report is being processed and will be sent to ${
                  this.$auth.user().email
                }. Please check your email in a few minutes.`
              });
              this.badgeStatsReportEmailSent = true;
            } else if (!jsonResponse) {
              const mimeType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
              const blob = new Blob([response.data], { type: mimeType });
              const downloadUrl = URL.createObjectURL(blob);
              const a = document.createElement("a");

              a.download = `badges_stats_from_${payload.startDate}_to_${payload.endDate}`;
              a.href = downloadUrl;

              document.body.appendChild(a);
              a.click();
            }
          }
          this.processingBadgesDownload = false;
        })
        .catch(error => {
          console.error("Error:", error);
          // Handle error here, if needed
        });
    },

    downloadOrganizationSummaryReport() {
      this.processingDownload = true;
      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.organizationSummaryStartDate
          ? this.formatDateForRequest(this.organizationSummaryStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.organizationSummaryEndDate
          ? this.formatDateForRequest(this.organizationSummaryEndDate)
          : this.today().formatted
      };
      this.organizationSummaryReportEmailSent = false;
      this.organizationSummaryDownload(payload).then(response => {
        if (
          !this._.has(response, "data") ||
          this._.has(response, "data.error.message")
        ) {
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message: this._.get(
              response,
              "data.error.message",
              `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
            )
          });
        }
        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.organizationSummaryReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.download = `organization_summary_from_${payload.startDate}_to_${payload.endDate}`;
          a.href = downloadUrl;
          document.body.appendChild(a);
          a.click();
        }
        this.processingDownload = false;
      });
    },

    downloadResellerAggregateStats() {
      this.processingResellerDownload = true;
      this.resellerAggregateReportEmailSent = false;

      this.resellerAggregateStatsDownload(this.userResellerId).then(
        response => {
          if (
            !this._.has(response, "data") ||
            this._.has(response, "data.error.message")
          ) {
            this.snackBar({
              duration: 10000,
              type: "is-danger",
              message: this._.get(
                response,
                "data.error.message",
                `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
              )
            });
          } else {
            this.resellerAggregateReportEmailSent = true;

            this.snackBar({
              duration: 5000,
              type: "is-success",
              message:
                "Your report is being generated and will be emailed to you shortly."
            });
          }

          this.processingResellerDownload = false;
        }
      );
    }
  }
};
</script>

<style lang="sass" scoped>
.no-padding
  padding: 0px

small
  color: $grey
  font-size: 12px

.mt-5
  margin-top: 31px !important

.reportTile
  background-color: $grey-lighter

  .wt-tile
    background-color: $grey-lighter

.card
  overflow: visible
</style>
